import { InfoModalForm } from "./InfoModalFormCandidato"


const InfoModalFormWrapper = () => {
    return (<InfoModalForm />)
}

export {InfoModalFormWrapper}